export default __webpack_public_path__ + "static/media/401.5c530f9a.png";